export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '运输单号',
                value: 'taskNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '客户订单号',
                value: 'customerOrderNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '客户',
                value: 'customerName',
                type: 'advance',
                unfold: true,
                span: 3,
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                ],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName']
            },
            {
                name: '创建时间',
                value: 'searchTime',
                type: 'time',
                unfold: true,
                span: 6,
                timeNum: 2,
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间'
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 70,
        selectBtn: false,
        columns: [
            {
                label: '进度',
                prop: 'orderMonitorList',
                type: 'progress',
                width: 150
            },
            {
                label: '发运类型',
                prop: 'shippingType',
                type: 'select',
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '分公司',
                prop: 'companyName',
                sort: true,
                width: 150
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 150,
                sort: true
            },
            {
                label: '客户单号',
                prop: 'customerOrderNo',
                width: 150,
                sort: true
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                width: 150,
                sort: true
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                width: 150,
                sort: true
            },
            {
                label: '运输单状态',
                prop: 'taskStatus',
                width: 120,
                type: 'select',
                optionNum: 'TRANSPORT_STATUS',
                options: [],
                sort: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: 150,
                sort: true
            },
            {
                label: '客户名称',
                prop: 'customerName',
                width: 180,
                sort: true
            },
            {
                label: '是否分拨',
                prop: 'distributionFlag',
                width: 120,
                type: 'select',
                optionNum: 'DISTRIBUTION_FLAG',
                options: [],
                sort: true
            },
            {
                label: '承运商',
                prop: 'carrierName',
                width: 150,
                sort: true
            },
            {
                label: '车牌',
                prop: 'vehicleCard',
                width: 120,
                sort: true
            },
            {
                label: '司机',
                prop: 'driver',
                width: 120,
                sort: true
            },
            {
                label: '仓库',
                prop: 'whName',
                width: 150,
                sort: true
            },
            {
                label: '发车单状态',
                prop: 'dispatchStatus',
                type: 'select',
                optionNum: 'DISPATCH_STATUS',
                options: [],
                width: 120,
                sort: true
            },
            {
                label: '采购渠道',
                prop: 'procurementChannel',
                width: 120,
                type: 'select',
                optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
                options: [],
                sort: true
            },
            {
                label: '订单类型',
                prop: 'orderType',
                type: 'select',
                optionNum: 'ORDER_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '任务类型',
                prop: 'taskType',
                type: 'select',
                optionNum: 'TASK_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '业务模式',
                prop: 'businessMode',
                optionNum: 'BUSINESS_MODE',
                type: 'select',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '来源系统',
                prop: 'sourceSystem',
                optionNum: 'SOURCE_SYSTEM',
                type: 'select',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '配送类型',
                prop: 'deliveryType',
                optionNum: 'DELIVERY_TYPE',
                type: 'select',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '目的地省',
                prop: 'receiverProvinceName',
                width: 120,
                sort: true
            },
            {
                label: '目的地市',
                prop: 'receiverCityName',
                sort: true,
                width: 120
            },
            {
                label: '目的地区',
                prop: 'receiverDistrictName',
                sort: true,
                width: 120
            },
            {
                label: '目的地乡镇',
                prop: 'receiverTownName',
                sort: true,
                width: 120
            },
            {
                label: '收货详细地址',
                prop: 'receiverDetailAddr',
                sort: true,
                width: 250
            },
            {
                label: '收货人',
                prop: 'receiverName',
                sort: true,
                width: 120
            },
            {
                label: '收货人手机号码',
                prop: 'receiverMobile',
                sort: true,
                width: 120
            },
            {
                label: '发货地省',
                prop: 'senderProvinceName',
                width: 120,
                sort: true
            },
            {
                label: '发货地市',
                prop: 'senderCityName',
                sort: true,
                width: 120
            },
            {
                label: '发货地区',
                prop: 'senderDistrictName',
                sort: true,
                width: 120
            },
            {
                label: '发货地乡镇',
                prop: 'senderTownName',
                sort: true,
                width: 120
            },
            {
                label: '线路',
                prop: 'lineName',
                sort: true,
                width: 180
            },
            {
                label: '实时位置跟踪',
                prop: 'trackingLocationName',
                sort: true,
                width: 180
            },
            {
                label: '最后跟踪时间',
                prop: 'lastTrackingDate',
                sort: true,
                width: 180
            },
            {
                label: '预计到货时间',
                prop: 'besArriveDate',
                sort: true,
                width: 180
            },
            {
                label: '收货单位',
                prop: 'upperReceiverName',
                sort: true,
                width: 180
            },
            {
                label: '里程',
                prop: 'mileage',
                sort: true,
                width: 120
            },
            {
                label: '跟踪方式',
                prop: 'trackingSource',
                type: 'select',
                optionNum: 'TMS_TRACKING_SOURCE',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '数量',
                prop: 'totalQty',
                sort: true,
                width: 120
            },
            {
                label: '体积(m³)',
                prop: 'totalVolume',
                sort: true,
                width: 120
            },
            {
                label: '重量(kg)',
                prop: 'totalGrossWeight',
                sort: true,
                width: 120
            },
            {
                label: '签收类型',
                prop: 'deliveredVerifyFlag',
                optionNum: 'DELIVERED_VERIFY_FLAG',
                type: 'select',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '班次要求到车时间',
                prop: 'requireCarArriveTime',
                sort: true,
                width: 150
            },
            {
                label: '实际到车时间',
                prop: 'actualArriveDate',
                sort: true,
                width: 150
            },
            {
                label: '到车是否延误',
                prop: 'isCarArriveDelay',
                sort: true,
                width: 120
            },
            {
                label: '班次要求装车时间',
                prop: 'requiredLoadDate',
                sort: true,
                width: 150
            },
            {
                label: '实际装车时间',
                prop: 'loadDate',
                sort: true,
                width: 150
            },
            {
                label: '装车是否延误',
                prop: 'isLoadDelay',
                sort: true,
                width: 120
            },
            {
                label: '班次要求发车时间',
                prop: 'requireDepartTime',
                sort: true,
                width: 150
            },
            {
                label: '实际发车时间',
                prop: 'actDepartTime',
                sort: true,
                width: 150
            },
            {
                label: '发车是否延误',
                prop: 'isDepartDelay',
                sort: true,
                width: 120
            },
            {
                label: '班次要求抵达时间',
                prop: 'requireArriveTime',
                sort: true,
                width: 150
            },
            {
                label: '实际抵达时间',
                prop: 'arrivalTime',
                sort: true,
                width: 150
            },
            {
                label: '抵达是否延误',
                prop: 'isArriveDelay',
                sort: true,
                width: 120
            },
            {
                label: '设备号',
                prop: 'deviceNo',
                sort: true,
                width: 120
            },
            {
                label: '事业部集拼号',
                prop: 'assembleNo',
                sort: true,
                width: 120
            }
        ],
        action: [
            {
                type: 'text',
                label: '日志',
                size: 'small',
                event: 'daily'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: [
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '分公司名称' },
                { prop: 'escoCompanyNo', value: '分公司编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '分公司名称' },
                { prop: 'escoCompanyNo', value: '分公司编码' }
            ],
            advanceUrl: '/searchBrand',
            cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode']
        },
        {
            name: '服务平台',
            value: 'siteName',
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            advanceUrl: '/searchPlatform',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
        },
        {
            name: '是否下发供应商',
            value: 'carrierVisibleFlag',
            type: 'select',
            optionNum: 'TMS_YES_OR_NO',
            options: [],
            sort: true,
            width: 180
        },
        {
            name: '业务模式',
            value: 'businessMode',
            type: 'select',
            optionNum: 'BUSINESS_MODE',
            options: []
        },
        {
            name: '来源系统',
            value: 'sourceSystem',
            type: 'select',
            optionNum: 'SOURCE_SYSTEM',
            options: []
        },
        {
            name: '运输单状态',
            value: 'taskStatus',
            type: 'select',
            optionNum: 'TRANSPORT_STATUS',
            options: []
        },
        {
            name: '仓库',
            value: 'whName',
            multiple: true,
            border: true,
            multipleTableColumn: {
                prop: 'cdwhName',
                value: '仓库名称'
            },
            advanceConfig: [
                { prop: 'cdwhName', value: '仓库名称' },
                { prop: 'whCode', value: '仓库编码' }
            ],
            tableConfig: [
                { prop: 'whCode', value: '仓库编码' },
                { prop: 'cdwhName', value: '仓库名称' }
            ],
            advanceUrl: 'cdWarehouse/search?cdwhIsStop=0',
            cbParams: ['whCode', 'cdwhName#whName'],
            type: 'advance'
        },
        {
            name: '司机',
            value: 'driver',
            type: 'input'
        },
        {
            name: '车牌号',
            value: 'vehicleCard',
            type: 'input'
        },
        {
            name: '是否分拨订单',
            value: 'distributionFlag',
            type: 'select',
            optionNum: 'DISTRIBUTION_FLAG',
            options: []
        },
        // {
        //     name: '采购渠道',
        //     value: 'procurementChannel',
        //     type: 'select',
        //     optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
        //     options: []
        // },
        {
            name: '发运类型',
            value: 'shippingType',
            type: 'select',
            optionNum: 'TMS_SHIPPING_TYPE',
            options: []
        },
        {
            name: '预约时间',
            value: 'appointmentTime',
            type: 'time',
            startPlaceholder: '预约开始时间',
            endPlaceholder: '预约结束时间'
        },
        {
            name: '事业部集拼号',
            value: 'assembleNo',
            type: 'input'
        }
    ]
};
